import React from 'react';
import cx from 'classnames';

import styles from './Skeleton.module.scss';
import Box from '../Box';

export interface RectangleProps {
  /** Specify the shape of the skeleton container. */
  appearance?: 'rectangle' | 'circle' | 'square';
  /** Custom className to override or add styles to the component. */
  className?: Parameters<typeof cx>[0];
  /** Specify the animation effect. */
  effect?: 'default' | 'sheen';
  /** Specify an arbitrary skeleton height. */
  height?: string;
  /** Specify the dimensions (equal width & height) of the skeleton. */
  size?: never;
  /** Specify an arbitrary skeleton width. */
  width?: string;
}

export interface EvenShapeProps {
  /** Specify the shape of the skeleton container. */
  appearance?: 'square' | 'circle';
  /** Custom className to override or add styles to the component. */
  className?: Parameters<typeof cx>[0];
  /** Specify the animation effect. */
  effect?: 'default' | 'sheen';
  /** Specify the arbitrary height of the skeleton. */
  height?: never;
  /** Specify the dimensions (equal width & height) of the skeleton. */
  size: string;
  /** Specify an arbitrary skeleton width. */
  width?: never;
}

export type SkeletonProps = RectangleProps | EvenShapeProps;

export const Skeleton: React.FC<SkeletonProps> = ({
  appearance = 'rectangle',
  className,
  effect,
  height,
  size,
  width,
}) => {
  // Storing the size as a CSS variable to make it more flexible.
  const sizeStyle = { '--skeleton-size': size } as React.CSSProperties;

  return (
    <Box
      className={cx(
        styles.skeleton,
        size && styles.evenShape,
        appearance && styles[appearance],
        effect && styles[effect],
        className,
      )}
      style={sizeStyle}
      height={height}
      width={width}
      aria-live='polite'
      aria-busy='true'
    ></Box>
  );
};

Skeleton.displayName = 'Skeleton';
export default Skeleton;
export { styles };
